/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DescendantServiceAccountInTenantQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("DescendantServiceAccountInTenantQueryOperator");
    }

    getFixupPrototypeFunction() { return DescendantServiceAccountInTenantQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<DescendantServiceAccountInTenantQueryOperator>): DescendantServiceAccountInTenantQueryOperator {
        let obj = Object.assign(new DescendantServiceAccountInTenantQueryOperator(), model);
        DescendantServiceAccountInTenantQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DescendantServiceAccountInTenantQueryOperator>): DescendantServiceAccountInTenantQueryOperator {
        if (!model) return null;
        return DescendantServiceAccountInTenantQueryOperator.newInstance(<DescendantServiceAccountInTenantQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DescendantServiceAccountInTenantQueryOperator) {
        if (!obj) return;

        models.DescendantServiceAccountInTenantQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DescendantServiceAccountInTenantQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DescendantServiceAccountInTenantQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant IDs associated with the ancestor service accounts of matching accounts.
     */
    tenant_ids: Array<string>;

}
